import * as S from './Image.styled'

export const Image = ({ src, ...props }) => <S.Image src={src} {...props} />

export default Image
